export enum AgeRangeEnum {
  ALL = 'all',
  AGE_BELOW_15 = 'AGE_BELOW_15',
  AGE_16_TO_20 = 'AGE_16_TO_20',
  AGE_21_TO_30 = 'AGE_21_TO_30',
  AGE_31_TO_40 = 'AGE_31_TO_40',
  AGE_41_TO_50 = 'AGE_41_TO_50',
  AGE_ABOVE_50 = 'AGE_ABOVE_50',
}
